export const manifest = {
  screens: {
    scr_otwrq6: { name: "Renacida — Carta de venta", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
  },
}
